import { Injectable } from "@angular/core";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {
  BottomSheetAttributesComponent
} from "../modules/shared/components/bottom-sheet-attributes/bottom-sheet-attributes.component";
import { MapItemData } from "../model/general.model";

@Injectable({
  providedIn: 'root'
})
export class BottomSheetService {

  constructor(
    private bottomSheet: MatBottomSheet
  ) {
  }

  open(data: MapItemData) {
    this.bottomSheet.open(BottomSheetAttributesComponent, {
      data,
      disableClose: true
    })
  }
}
